// src/components/ExportButtons.jsx
import { useState } from "react";
import { getAuth } from "firebase/auth";

const EXPORTAR_CHATS_URL = process.env.NEXT_PUBLIC_FUNCTION_EXPORTAR_CHATS_URL || "https://exportarchats-myxat54wua-uc.a.run.app";
const EXPORTAR_MENSAJES_URL = process.env.NEXT_PUBLIC_FUNCTION_EXPORTAR_MENSAJES_URL || "https://exportarmensajes-myxat54wua-uc.a.run.app";

async function downloadResponseAsFile(resp, filename) {
  const blob = await resp.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

async function authedFetch(url) {
  const user = getAuth().currentUser;
  if (!user) throw new Error("missing token");
  const idToken = await user.getIdToken();
  const resp = await fetch(url, { headers: { Authorization: `Bearer ${idToken}` } });
  if (!resp.ok) {
    let err = "request failed";
    try { const j = await resp.clone().json(); err = j.error || err; } catch {}
    throw new Error(`${resp.status} ${err}`);
  }
  return resp;
}

export async function exportChats({ clienteID, formato = "csv", canal, organizationId }) {
  const params = new URLSearchParams({ clienteID, formato });
  if (canal && canal !== 'todos') params.set('canal', canal);
  // Sin esto, en modo organización el backend leería la ruta personal —vacía en los 18
  // tenants— y devolvería "No hay chats para exportar" con la pantalla llena de chats.
  // Y desde el 10-sep-2026 la función además comprueba la MEMBRESÍA con este mismo
  // valor, así que omitirlo no es exportar de menos: es no exportar.
  if (organizationId) params.set('organizationId', organizationId);
  const url = `${EXPORTAR_CHATS_URL}?${params.toString()}`;
  const resp = await authedFetch(url);
  const filename = `chats_${clienteID}.${formato}`;
  await downloadResponseAsFile(resp, filename);
  return true;
}

export async function exportMensajes({ clienteID, chatID, formato = "csv", canal, threadId, organizationId }) {
  const params = new URLSearchParams({ clienteID, chatID, formato });
  if (canal && canal !== 'todos') params.set('canal', canal);
  if (threadId) params.set('threadId', threadId);
  if (organizationId) params.set('organizationId', organizationId);
  const url = `${EXPORTAR_MENSAJES_URL}?${params.toString()}`;
  const resp = await authedFetch(url);
  const filename = `mensajes_${chatID}.${formato}`;
  await downloadResponseAsFile(resp, filename);
  return true;
}

export default function ExportButtons({ clienteID, chatID, organizationId = null }) {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState(null);

  const doExport = (fn) => async () => {
    setErr(null); setLoading(true);
    try { await fn(); } catch (e) { setErr(e.message || "Error"); } finally { setLoading(false); }
  };

  return (
    <div style={{ display: "grid", gap: 8 }}>
      <div style={{ fontSize: 12, opacity: 0.7 }}>Cliente: {clienteID} {chatID ? `| Chat: ${chatID}` : ""}</div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        <button disabled={loading} onClick={doExport(() => exportChats({ clienteID, formato: "csv", organizationId }))}>Chats CSV</button>
        <button disabled={loading} onClick={doExport(() => exportChats({ clienteID, formato: "xlsx", organizationId }))}>Chats XLSX</button>
        <button disabled={loading || !chatID} onClick={doExport(() => exportMensajes({ clienteID, chatID, formato: "csv", organizationId }))}>Mensajes CSV</button>
        <button disabled={loading || !chatID} onClick={doExport(() => exportMensajes({ clienteID, chatID, formato: "xlsx", organizationId }))}>Mensajes XLSX</button>
      </div>
      {loading && <div>Exportando…</div>}
      {err && <div style={{ color: "crimson" }}>Error: {err}</div>}
    </div>
  );
}